import React from 'react';

const CheckInChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 6h2v12h-2v2h4V4h-4v2zM16 12l-5-5-1.4 1.4 2.6 2.6H4v2h8.2l-2.6 2.6L11 17z"
        />
    </svg>
);

CheckInChunkySvg.displayName = 'CheckInChunkySvg';
export default CheckInChunkySvg;
